module.exports = __webpack_public_path__ + "static/redwaffle-104586b9fc56ef16f3949b642e4a0770.jpeg";